import type { ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"

import { METRICS_READ, USERS_READ } from "@/auth/scopes"
import { useScopes } from "@/auth/useScopes"
import { RequireScope } from "@/components/auth/RequireScope"

export const USERS_OVERVIEW_PATH = "/admin/users"
export const USERS_PEOPLE_PATH = "/admin/users/list"

/** /admin/users itself: the Overview, or People for somebody who can read
 *  people but not aggregates, so the nav entry never lands on a refusal. */
export function UsersIndexRoute({ children }: { children: ReactNode }) {
  const { can } = useScopes()
  const location = useLocation()
  if (!can(METRICS_READ) && can(USERS_READ)) {
    return <Navigate to={{ pathname: USERS_PEOPLE_PATH, search: location.search }} replace />
  }
  return <RequireScope scopes={[METRICS_READ]}>{children}</RequireScope>
}
